const $win = $(window);
const mobileWidth = 767;
const tabletWidth = 1023;

/**
 * Check if user is on mobile
 *
 * @return {Void}
 */
 export const deviceIsMobile = () => $win.outerWidth() <= mobileWidth;

 /**
  * Check if user is on mobile
  *
  * @return {Void}
  */
 export const deviceIsTablet = () => $win.outerWidth() <= tabletWidth;
